import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Mail, Lock, LogIn } from 'lucide-react'
import { useAuth } from '../context/AuthContext'

const LoginPage = () => {
  const navigate = useNavigate()
  const { login } = useAuth()
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const success = await login(formData)
    setLoading(false)
    if (success) {
      navigate('/')
    }
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <main data-component-path="client/src/pages/LoginPage.jsx" data-component-line="32:4" data-component-id="client/src/pages/LoginPage.jsx:32:4" className="pt-20 min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center px-4">
      <div data-component-path="client/src/pages/LoginPage.jsx" data-component-line="33:6" data-component-id="client/src/pages/LoginPage.jsx:33:6" className="max-w-md w-full">
        <div data-component-path="client/src/pages/LoginPage.jsx" data-component-line="34:8" data-component-id="client/src/pages/LoginPage.jsx:34:8" className="bg-white rounded-2xl shadow-xl p-8">
          <div data-component-path="client/src/pages/LoginPage.jsx" data-component-line="35:10" data-component-id="client/src/pages/LoginPage.jsx:35:10" className="text-center mb-8">
            <h1 data-component-path="client/src/pages/LoginPage.jsx" data-component-line="36:12" data-component-id="client/src/pages/LoginPage.jsx:36:12" className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h1>
            <p data-component-path="client/src/pages/LoginPage.jsx" data-component-line="37:12" data-component-id="client/src/pages/LoginPage.jsx:37:12" className="text-gray-600">Sign in to your HelplineAgent account</p>
          </div>

          <form data-component-path="client/src/pages/LoginPage.jsx" data-component-line="40:10" data-component-id="client/src/pages/LoginPage.jsx:40:10" onSubmit={handleSubmit} className="space-y-6">
            <div data-component-path="client/src/pages/LoginPage.jsx" data-component-line="41:12" data-component-id="client/src/pages/LoginPage.jsx:41:12">
              <label data-component-path="client/src/pages/LoginPage.jsx" data-component-line="42:14" data-component-id="client/src/pages/LoginPage.jsx:42:14" htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <div data-component-path="client/src/pages/LoginPage.jsx" data-component-line="45:14" data-component-id="client/src/pages/LoginPage.jsx:45:14" className="relative">
                <Mail data-component-path="client/src/pages/LoginPage.jsx" data-component-line="46:16" data-component-id="client/src/pages/LoginPage.jsx:46:16" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input data-component-path="client/src/pages/LoginPage.jsx" data-component-line="47:16" data-component-id="client/src/pages/LoginPage.jsx:47:16"
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full h-11 pl-10 pr-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  placeholder="you@example.com"
                />
              </div>
            </div>

            <div data-component-path="client/src/pages/LoginPage.jsx" data-component-line="61:12" data-component-id="client/src/pages/LoginPage.jsx:61:12">
              <label data-component-path="client/src/pages/LoginPage.jsx" data-component-line="62:14" data-component-id="client/src/pages/LoginPage.jsx:62:14" htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <div data-component-path="client/src/pages/LoginPage.jsx" data-component-line="65:14" data-component-id="client/src/pages/LoginPage.jsx:65:14" className="relative">
                <Lock data-component-path="client/src/pages/LoginPage.jsx" data-component-line="66:16" data-component-id="client/src/pages/LoginPage.jsx:66:16" className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input data-component-path="client/src/pages/LoginPage.jsx" data-component-line="67:16" data-component-id="client/src/pages/LoginPage.jsx:67:16"
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full h-11 pl-10 pr-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  placeholder="••••••••"
                />
              </div>
            </div>

            <button data-component-path="client/src/pages/LoginPage.jsx" data-component-line="81:12" data-component-id="client/src/pages/LoginPage.jsx:81:12"
              type="submit"
              disabled={loading}
              className="w-full h-11 px-6 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 flex items-center justify-center gap-2 transition-all duration-200 shadow-md hover:shadow-lg font-medium"
            >
              {loading ? 'Signing in...' : 'Sign In'}
              <LogIn data-component-path="client/src/pages/LoginPage.jsx" data-component-line="87:14" data-component-id="client/src/pages/LoginPage.jsx:87:14" className="w-5 h-5" />
            </button>
          </form>

          <div data-component-path="client/src/pages/LoginPage.jsx" data-component-line="91:10" data-component-id="client/src/pages/LoginPage.jsx:91:10" className="mt-6 text-center">
            <p data-component-path="client/src/pages/LoginPage.jsx" data-component-line="92:12" data-component-id="client/src/pages/LoginPage.jsx:92:12" className="text-gray-600">
              Don't have an account?{' '}
              <Link data-component-path="client/src/pages/LoginPage.jsx" data-component-line="94:14" data-component-id="client/src/pages/LoginPage.jsx:94:14" to="/signup" className="text-blue-600 hover:text-blue-700 font-medium">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>
    </main>
  )
}

export default LoginPage